import { render, staticRenderFns } from "./ErrorResponses.vue?vue&type=template&id=637adc7a&scoped=true"
import script from "./ErrorResponses.vue?vue&type=script&lang=js"
export * from "./ErrorResponses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637adc7a",
  null
  
)

export default component.exports